import { flatten, includes } from 'lodash'
import React, { Component } from 'react'
import languageService from "../../../services/languageService";
import parameterService from '../../../services/parameterService';

class ExpiryInput extends Component {
    constructor(props) {
        super(props);

        const prefillData = parameterService.prefillData;
        const value = (prefillData.ExpiryMonth.length > 0 && prefillData.ExpiryYear.length > 0) ? prefillData.ExpiryMonth + ' / ' + prefillData.ExpiryYear.substr(2,2) : '';

        this.state = {
            value: value,
            valid: false
        }
    }

    /**
     *
     * @param event
     */
    onChange = event => {
        const el = event.target;
        let currentValue = el.value;

        if(currentValue.length === 7) {
            currentValue = currentValue[0] + currentValue[1] + currentValue[5] + currentValue[6];
        }

        const cursorIndex = el.selectionStart;
        const value = this.formatValue({ value: currentValue, cursorIndex });
        const raw = this.getRawValue({value});
        const valid = this.validateValue({value});

        const payload = { value, valid, raw };
        this.setState(payload);
        this.props.onChange(payload);
    };
    /**
     * Returns the raw expiration date without formatting (MMYY)
     * @param value
     * @returns {*}
     */
    getRawValue = ({value}) => {
        return value.replace(/\D/g, '');
    };

    /**
     * Format value
     * @param value
     * @param cursorIndex
     * @returns {*}
     */
    formatValue = ({ value, cursorIndex }) => {
        let raw = this.getRawValue({value});

        const digit1 = raw[0] || '';
        const digit2 = raw[1] || '';

        if(!includes(['0', '1'], digit1)) {
          return '';
        }

        const month = parseInt(digit1 + digit2, 10);

        if(month > 12 || month === 0) {
            return digit1;
        }

        // Add slash
        if (raw.length >= 2 && cursorIndex !== 4) {
            raw = raw.split('').map((char, index) => {
                return index === 1 ? [char, ' / '] : char;
            });
        }

        return flatten(raw).join('').substr(0, 7);
    };

    /**
     * Check if the entered and formatted date is in the future
     * @param value
     * @returns {boolean}
     */
    validateValue = ({value}) => {
        const raw = this.getRawValue({value});

        if(raw.length !== 4) {
            return true;
        }

        const expMonth = parseInt(raw.substr(0,2), 10);
        const expYear = parseInt('20' + raw.substr(2,2), 10);

        // 0 = last day of previous month
        const expDate = new Date(expYear, expMonth, 0);
        const currDate = new Date();

        return expDate > currDate;
    };

    render() {
        const { value } = this.state;

        return (
            <input className="form-control" type="text" inputMode="numeric"
                   pattern="\d*" id="expMonth"
                   value={value}
                   autoComplete="cc-exp"
                   autoCorrect="off"
                   spellCheck="false"
                   maxLength="7"
                   onChange={this.onChange}
                   onBlur={this.props.onBlur} placeholder={
                languageService.texts.expMonth + " / " + languageService.texts.expYear
            }/>
        )
    }
}

ExpiryInput.defaultProps = {
    onBlur: () => {
    },
    onChange: () => {
    }
};

export default ExpiryInput



// WEBPACK FOOTER //
// ./src/components/CreditCard/ExpiryInput/ExpiryInput.js